import { FacebookIcon } from "@icons/FacebookIcon";
import { GoogleIcon } from "@icons/GoogleIcon";
import { MailIcon } from "@icons/MailIcon";
import { SmartPhoneIcon } from "@icons/SmartPhoneIcon";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import React from "react";
import { useTranslation } from "react-i18next";
import type { SocialAuthType } from "./SocialAuth";
import { ButtonHTMLType } from "antd/es/button";
interface SocialAuthButtonProps {
  provider: SocialAuthType;
  onPress?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
  htmlType?: ButtonHTMLType;
}

const IconMap = {
  facebook: FacebookIcon,
  google: GoogleIcon,
  email: MailIcon,
  sms: SmartPhoneIcon,
};

export const SocialAuthButton = ({
  provider,
  onPress,
  disabled,
  htmlType = "button",
}: SocialAuthButtonProps) => {
  const { t } = useTranslation();
  const Icon = IconMap[provider];

  return (
    <>
      <TabButton
        label={t(`authentication.socialAuth.${provider}`)}
        variant="outline"
        size="default"
        fullWidth={true}
        htmlType={htmlType}
        onPress={onPress}
        iconPrefix={<Icon size={16} />}
        disabled={disabled}
      />
    </>
  );
};
